import { FLIGHT } from '../constants'

export const setFlight = (flightSelected) => ({
	type: FLIGHT.SET_FLIGHT,
	flightSelected,
})
